export default "__VITE_ASSET__PM1Gvi1e__"